import React, { useEffect, useState } from "react";
import { getFromMemory, saveToMemory } from "@utils/storage.utils";
import { ILanguageFillter, ILanguages } from "src/types";
import { fetchAllLanguages } from "src/service/api-services/api-services";
import showToast from "@utils/toast";

interface LanguageFilterProps {
  selectedLanguage: string;
  onLanguageChange: (language: string) => void;
}

const LanguageFilter: React.FC<LanguageFilterProps> = ({
  selectedLanguage,
  onLanguageChange,
}) => {
  const [languages, setLanguages] = useState<ILanguageFillter>({
    isLoading: true,
    languages: [],
  });

  useEffect(() => {
    fetchAllLanguages()
      .then((data) => {
        const { status, result } = data;
        if (status !== "success") {
          setLanguages({ isLoading: false, languages: [] });
          return showToast("Can't fetch languages at the moment", false);
        }
        setLanguages({ isLoading: false, languages: result });
      })
      .catch((error) => {
        const message =
          error instanceof Error
            ? error?.message
            : "Apologies there was an error fetching languages!";
        setLanguages({ isLoading: false, languages: [] });
        return showToast(message, false);
      });
  }, []);

  useEffect(() => {
    if (selectedLanguage) {
      saveToMemory("language", selectedLanguage);
    }
  }, [selectedLanguage]);

  return (
    // container mx-auto px-4 py-2 flex justify-end
    <div className="">
      <label
        htmlFor="language-select"
        className="font-medium text-gray-700 mt-1 mr-2"
      >
        Filter by Language:
      </label>
      <select
        id="language-select"
        className="border border-gray-300 rounded-md px-3 py-2"
        value={selectedLanguage}
        onChange={(e) => onLanguageChange(e.target.value)}
      >
        {!selectedLanguage && (
          <option value="" disabled>
            {languages.isLoading ? "Loading...." : "Select Language"}
          </option>
        )}
        {languages.languages.map((lang) => (
          <option key={lang.code} value={lang.name.toLowerCase()}>
            {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageFilter;
